import React, { Fragment, useEffect } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { splitNumberDigits } from 'helpers/math'
import { dateFormat } from 'helpers/date'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import modalStore from 'Stores/modalStore'
import ContentHeader from '../ContentHeader'
import THead from './THead'
import Loader from '../Loader/Loader'
import ModalCorrectVacationDays from './ModalCorrectVacationDays'
import st from './Table.module.scss'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import useLocalization from 'hooks/useLocalization'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import style from './VacationDays.module.scss'

function VacationDays(props) {
  const cfg = {
    cols: [
      {
        name: 'Месяц',
        group: true,
        dataField: 'name',
        classes: [st.color, st.fw500],
      },
      {
        name: 'День',
        dataField: 'day',
        align: 'center',
        classes: [st.fz12, st.color, st.fw500],
      },
      {
        name: 'Отработано, мин / часов',
        align: 'center',
        classes: [st.fz12],
        formatter: (row) =>
          `${formatNumber(row.worked_minutes)} мин. / ${formatTime(row.worked_hours)} ч.`,
      },
      { name: 'Изменения', dataField: 'comment', classes: [st.fz12] },
      {
        name: 'Начислено отпускных дней',
        align: 'center',
        formatter: (row) => (
          <span
            className={
              row.vacation_days >= 0 ? st.tdContentVacPos : st.tdContentVacNeg
            }
          >
            {formatNumber(row.vacation_days, 3)}
          </span>
        ),
      },
    ],
  }

  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
    getTdClassNames,
  } = useTableFixedHeader()

  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const filterCfg = [
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
    },
    {
      type: 'select',
      label: 'Контракт',
      placeholder: 'Контракт',
      apiLink: `employees/contract/?employee=${props.match.params.id}&limit=9999`,
      sort_key: 'title',
      nameState: 'contract_id',
    },
  ]

  const formatNumber = (num, frac) => {
    let parts = num.toString().split('.')
    if (frac !== undefined) {
      parts[1] = (parts[1] || '').padEnd(frac, '0').slice(0, frac)
    }
    return splitNumberDigits(parts.join(','))
  }

  const formatTime = (num) => {
    let [integerPart, decimalPart] = num.toString().split('.')
    if (decimalPart) {
      decimalPart = decimalPart.slice(0, 3)
    }
    const hour = [integerPart, decimalPart].filter(Boolean).join('.')
    return splitNumberDigits(hour)
  }

  const openModalCorrect = () => {
    const ms = {
      title: 'Корректировка отпускных дней',
      modalBodyComponent: () => <ModalCorrectVacationDays />,
      link: 'employees/vacation_minutes_correction/' + props.match.params.id,
      button: 'Сохранить',
      is_put: true,
      data: 'json',
      valid: {
        comment: 'required',
      },
      func: () => updateFilter({}),
    }
    const md = {
      type: 2,
      correction: -6,
      date: dateFormat(new Date(), 'YYYY-mm-dd'),
    }
    modalStore.activity(ms, md)
  }

  const fetchData = (params) => {
    setIsLoading(true)
    const apiConf = {
      method: 'get',
      link: 'employees/report_vacation_time/' + props.match.params.id,
      params,
    }
    superAxiosRequest(apiConf)
      .then((res) => {
        setData(res.data)
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }

  useEffect(() => {
    fetchData(filter)
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/vacation-days') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : data ? (
        <>
          <ContentHeader
            title={`${data.last_name || ''} ${data?.first_name || ''}: История начисления отпускных дней`}
            textButton={{ text: 'Корректировка', onClick: openModalCorrect }}
          />

          <div className={style.filter}>
            <SearchBooks
              onSearch={(text) => {
                updateFilter({ ...filter, search: text })
                changeTextValue('search', {
                  key: 'search',
                  label: 'Search',
                  value: text,
                })
              }}
              onClear={() => {
                const { search, ...obj } = filter
                updateFilter(obj)
                setTextValues(
                  filterTextValues.filter((field) => field.key !== 'search'),
                )
              }}
              translate={translate}
              placeholder={`Search...`}
              value={filter?.search || ''}
              // isFilterEmpty={isFilterEmpty}
            />
            {!!filterTextValues.length && (
              <FilterTextValues
                onDelete={(key) => {
                  const { [key]: _, ...obj } = filter
                  updateFilter(obj)
                }}
              />
            )}
            {isOpenFilter && (
              <AsideFilter
                translate={translate}
                getFilterParams={updateFilter}
                config={filterCfg}
                filterValue={filter}
                onDropFilter={() => {
                  updateFilter({})
                  closeFilter()
                }}
              />
            )}
          </div>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cfg.cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cfg.cols} ref={refThead} />
              <tbody className={st.tbody}>
                {data.total && (
                  <>
                    <tr className={st.bdt}>
                      <td colSpan={cfg.cols.length - 1} className={st.tdTotal}>
                        ИТОГО, начислено
                      </td>
                      <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                        {formatNumber(data.total.days, 2)} д.
                      </td>
                    </tr>
                    <tr className={st.bdt}>
                      <td colSpan={cfg.cols.length - 1} className={st.tdTotal}>
                        ИТОГО, остаток дней
                      </td>
                      <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                        {formatNumber(data.total.days_remain, 2)} д.
                      </td>
                    </tr>
                  </>
                )}

                {Array.isArray(data.months) &&
                  data.months.map((row, idxRow) => (
                    <Fragment key={idxRow}>
                      {row.days?.map((subRow, idxSubRow) => (
                        <tr
                          key={`${idxRow}-${idxSubRow}`}
                          className={idxSubRow === 0 ? st.bdt : undefined}
                        >
                          {cfg.cols.map((col, idxCol) =>
                            col.group ? (
                              idxSubRow === 0 && (
                                <td
                                  key={idxCol}
                                  rowSpan={row.days.length + 1}
                                  className={getTdClassNames(col)}
                                >
                                  {typeof col.formatter === 'function'
                                    ? col.formatter(row)
                                    : row[col.dataField]}
                                </td>
                              )
                            ) : (
                              <td key={idxCol} className={getTdClassNames(col)}>
                                {typeof col.formatter === 'function'
                                  ? col.formatter(subRow)
                                  : subRow[col.dataField]}
                              </td>
                            ),
                          )}
                        </tr>
                      ))}
                      <tr>
                        <td
                          colSpan={cfg.cols.length - 2}
                          className={st.tdTotal}
                        >
                          Итог: {row.name}
                        </td>
                        <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                          {formatNumber(row.total.days, 3)} д.
                        </td>
                      </tr>
                    </Fragment>
                  ))}

                {data.total && (
                  <>
                    <tr className={st.bdt}>
                      <td colSpan={cfg.cols.length - 1} className={st.tdTotal}>
                        ИТОГО, начислено
                      </td>
                      <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                        {formatNumber(data.total.days, 2)} д.
                      </td>
                    </tr>
                    <tr className={st.bdt}>
                      <td colSpan={cfg.cols.length - 1} className={st.tdTotal}>
                        ИТОГО, остаток дней
                      </td>
                      <td className={`${st.tdTotal} ${st.textAlignCenter}`}>
                        {formatNumber(data.total.days_remain, 2)} д.
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </>
  )
}

export default observer(VacationDays)
